export default __webpack_public_path__ + "static/about_diagram-b46c3818a07287b7eb80c51544541752.png";